import React from 'react'
import TextField from 'components/ui/text-field'
import PlaylistPresentationSocialLinks from './PlaylistPresentationSocialLinks'
import PlaylistPresentationSocialLinksShortlistContainer from './PlaylistPresentationSocialLinksShortlistContainer'
type Props = {
  params?: Record<string, any>
  onChange?: (...args: Array<any>) => any
  onClose?: (...args: Array<any>) => any
  onSave?: (...args: Array<any>) => any
  links?: Record<string, any>
  aggregatorLink?: string | null | undefined
}

const PlaylistPresentationSocialLinksContainer = ({
  params,
  onChange,
  onClose,
  onSave,
  links = {},
  aggregatorLink,
}: Props): null | React.ReactNode => {
  if (params && params.shortlistId) {
    return <PlaylistPresentationSocialLinksShortlistContainer />
  }

  if (!(onChange && onClose && onSave)) return null

  const renderRow = ({ value, placeholder, getIcon }) => {
    let textFieldValue = links && links[`${value}`]

    let onChangeInput = event => {
      onChange({
        [`${value}`]: event.target.value || null,
      })
    }

    if (value === 'social_links_aggregator') {
      textFieldValue = aggregatorLink

      onChangeInput = event => {
        onChange(event.target.value || null)
      }
    }

    // TODO: optimization, re-rendering of all fields when changing one
    return (
      <div key={value} className="PlaylistPresentationSocialLinks_Row">
        <TextField
          icon={getIcon('PlaylistPresentationSocialLinks_Icon')}
          placeholder={placeholder}
          type="url"
          value={textFieldValue || ''}
          onChange={onChangeInput}
        />
      </div>
    )
  }

  return (
    <PlaylistPresentationSocialLinks
      renderRow={renderRow}
      onClose={onClose}
      onSave={onSave}
    />
  )
}

export default PlaylistPresentationSocialLinksContainer
